<template>
  <b-modal title="Selecione o Produto" v-model="show" size="xl">
    <div class="modal-screen-list">
      <!-- :::::::::::::::::::::::::::: TABELA DE PRODUTOS :::::::::::::::::::::::::::: -->
      <b-table
        bordered
        hover
        small
        head-variant="light"
        :items="getFilterProdutos(filtro)"
        :fields="fields.produto"
      >
        <template #cell(valor)="data">
          <div>
            <p>{{ formatter.format(data.item.valor) }}</p>
          </div>
        </template>

        <template #cell(acoes)="data">
          <div>
            <b-button class="pt-0 pb-0" variant="link" @click="display(data.item)">
              <b-icon icon="image" variant="info"> </b-icon>
            </b-button>
            <b-button class="pt-0 pb-0" variant="link" @click="addProduto(data.item)">
              <b-icon icon="file-earmark-arrow-down" variant="info"> </b-icon>
            </b-button>
          </div>
        </template>
      </b-table>
    </div>
    <!-- :::::::::::::::::::::::::::: MODAL DE EXIBIÇÃO :::::::::::::::::::::::::::: -->
    <display-modal ref="display" :size="'lx'" />
    <template #modal-footer>
      <b-form inline>
        <b-form-input
          id="produto-filter-codigo"
          type="search"
          size="sm"
          class="m-1 p-1"
          placeholder="Filtre pelo código."
          v-model="filtro.codigo"
        />
        <b-form-input
          id="produto-filter-descricao"
          type="search"
          size="sm"
          class="m-1 p-1"
          placeholder="Filtre pela descrição."
          v-model="filtro.descricao"
        />
        <b-icon icon="search" variant="light" scale="1.2" class="m-1" />
      </b-form>
      <b-button variant="secondary" @click="show = !show">Fechar</b-button>
    </template>
  </b-modal>
</template>

<script>
import { useSgcqStore } from "@/stores/SgcqStore";
import { storeToRefs } from "pinia";
import { useProdutoStore } from "@/stores/ProdutoStore";
import TableFields from "@/tools/TableFields";
import DisplayModal from "@/components/modals/diversos/DisplayModal";
import Files from "@/http/files";

export default {
  name: "ProdutoListOrcamento",

  data() {
    return {
      show: false,
      fields: new TableFields(),
      filtro: { codigo: "", descricao: "" },
      files: new Files(this.$http),
      formatter: new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
        minimumFractionDigits: 2,
      }),
    };
  },

  components: {
    "display-modal": DisplayModal,
  },

  methods: {
    display(produto) {
      this.files.downloadProduto(produto.id).then((response) => this.$refs.display.call(response));
    },

    addProduto(produto) {
      this.$emit("addProduto", produto);
      this.show = !this.show;
    },

    call(orcamento) {
      this.show = !this.show;
      this.editing = orcamento;
    },
  },

  setup() {
    const store = useSgcqStore();
    const produtoStore = useProdutoStore();
    const { getFilterProdutos } = storeToRefs(produtoStore);

    return {
      store,
      produtoStore,
      getFilterProdutos,
    };
  },
};
</script>

<style lang="scss" scoped>
#produto-filter-codigo {
  width: 15rem;
}
#produto-filter-descricao {
  width: 30rem;
}
</style>
